import { useFormikContext, FormikContextType } from 'formik'

import { ButtonRebrand } from 'src/components/atoms/ButtonRebrand'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'
import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { CarbonCalculatorValues } from '../types'

export const IncludeOwnMeasurementsFormFields = () => {
  const { setFieldValue, values }: FormikContextType<CarbonCalculatorValues> =
    useFormikContext()

  return !values.includeOwnMeasurements ? (
    <>
      <div className='[&_.typography-rebrand-paragraph]:leading-snug'>
        <TypographyRebrand variant='paragraph' color='forestDeep'>
          This section is for planters who want to add measurements from their
          own plantings to calculate their emissions. If you&apos;re a business
          or funder wanting to work out how many trees you need to plant to
          mitigate your emissions as your trees grow over time just ignore this
          section.
        </TypographyRebrand>
      </div>
      <ButtonRebrand
        className='w-full'
        variant='lime'
        onClick={() => {
          setFieldValue('includeOwnMeasurements', true)
        }}
      >
        Add stand measurements
      </ButtonRebrand>
    </>
  ) : (
    <>
      <FormField
        id='standTreeAge'
        formFieldClassName='bg-white'
        type={FormFieldTypes.number}
        label='Age of stand when measured (years)'
      />
      <TypographyRebrand variant='h5' color='forestDeep'>
        Trees
      </TypographyRebrand>
      <div className='flex space-x-2 items-end'>
        <FormField
          id='standTreeSurvival'
          formFieldClassName='bg-white'
          type={FormFieldTypes.number}
          label='Survival (%)'
        />
        <FormField
          id='standTreeHeight'
          formFieldClassName='bg-white'
          type={FormFieldTypes.number}
          label='Height (m)'
        />
        <FormField
          id='standTreeDBH'
          formFieldClassName='bg-white'
          type={FormFieldTypes.number}
          label='DBH (cm)'
        />
      </div>
      <TypographyRebrand variant='h5' color='forestDeep'>
        Shrubs
      </TypographyRebrand>
      <div className='flex space-x-2 items-end'>
        <FormField
          id='standShrubSurvival'
          formFieldClassName='bg-white'
          type={FormFieldTypes.number}
          label='Survival (%)'
        />
        <FormField
          id='standShrubHeight'
          formFieldClassName='bg-white'
          type={FormFieldTypes.number}
          label='Height (m)'
        />
        <FormField
          id='standShrubRCD'
          formFieldClassName='bg-white'
          type={FormFieldTypes.number}
          label='RCD (cm)'
        />
      </div>
    </>
  )
}
